import styled from "styled-components";

export const NavBarElement = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #333;
  color: white;
  padding: 0 20px;
  height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const NavTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
`;

export const NavLinks = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const NavLink = styled.li`
  margin-left: 20px;
  
  a {
    color: white;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s;
    
    &:hover {
      color: #ddd;
    }
  }
`;

export const NavImg = styled.img`
    height: 50px;
    padding: 0 5px;
`
export const NavImageContainer = styled.div`
   
`